export default "__VITE_ASSET__d2b4befd__"